// clearAllMeetingsFromTrip — pure builder that empties the edited trip's meetings.
//
// Extracted verbatim from `EditTripModal.js` (the `setEditedTrip` updater behind
// the "Clear All" button that returns `{ ...prev, meetings: [] }`) as part of the
// behavior-preserving refactor (issue #240). It immutably builds the next trip
// with an empty `meetings` array.
//
// Totality preserved exactly: the source's updater only reset `meetings` to `[]`
// and spread the previous trip; this builder mirrors that exactly. The
// `window.confirm` gate and the `editedTrip.meetings.length > 1` visibility rule
// stay in the hook/container.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Returns the next edited trip with all meetings removed.
 *
 * @param {Object} editedTrip - The current edited-trip working copy.
 * @returns {Object} The next edited-trip object with `meetings: []`.
 */
export function clearAllMeetingsFromTrip(editedTrip) {
  return {
    ...editedTrip,
    meetings: []
  };
}

export default clearAllMeetingsFromTrip;
